import React, { ReactElement } from 'react';

interface Props {
  width?: string;
  height?: string;
}

const DescendingSort = (props: Props): ReactElement => {
  const { width, height } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 24 20">
      <path
        fill="#0074CC"
        d="M18.351 4.156l.02.018 3.45 3.364.016.016c.216.227.217.578.003.806l-.019.019-.016.015c-.233.21-.593.212-.827.002l-.02-.017L18.55 6.03v13.324c0 .329-.273.595-.61.595-.337 0-.61-.266-.61-.595V6.03l-2.41 2.349-.016.015c-.239.217-.613.211-.846-.015-.232-.227-.238-.59-.018-.823l.018-.018 3.45-3.364.017-.015c.226-.205.573-.212.807-.02l.02.017z"
      />
      <path
        fill="#C3C5C9"
        d="M7.06 4.051c.338 0 .61.266.61.595V17.97l2.41-2.349c.233-.226.607-.232.846-.015l.017.015c.233.227.238.592.016.825l-.016.016-3.45 3.364c-.234.227-.608.232-.847.015l-.017-.015-3.45-3.364c-.239-.232-.239-.608 0-.84.232-.227.607-.233.846-.016l.016.015 2.41 2.349V4.646c0-.329.273-.595.61-.595z"
      />
    </svg>
  );
};

DescendingSort.defaultProps = {
  width: '100%',
  height: '100%',
};

export default DescendingSort;
